import React from "react";
import { Editor } from "@toast-ui/react-editor";
import { withTranslation } from "react-i18next";
import ValidationHelper from "../../helpers/ValidationHelper";
import { Form } from "react-bootstrap";
import equal from "fast-deep-equal/es6";
import BaseSelect from "../baseSelect/BaseSelect";

import "./toastui-editor.css";
import "./MarkDownEditor.css";


class MarkDownEditor extends React.Component {
  constructor(props) {
    super(props);
    this.editorRef = React.createRef();
    this.languages = ValidationHelper.supportedLanguages;
    this.state = {
      languages: ValidationHelper.supportedLanguages,
      selectedLanguage: ValidationHelper.supportedLanguages[0],
      valueObject: this.props.defaultValue
        ? this.props.defaultValue
        : ValidationHelper.getDefaultValueExtendedDescription(),
      value: this.props.defaultValue
        ? this.props.defaultValue[ValidationHelper.supportedLanguages[0].code]
        : ""
    };

    this.handleLanguageChange = this.handleLanguageChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    this.editorRef.current
      .getInstance()
      .setMarkdown(this.state.valueObject[this.state.selectedLanguage.code]);
  }

  componentDidUpdate(prevProps) {
    if (!equal(this.props.defaultValue, prevProps.defaultValue)) {
      this.setState({
        valueObject: this.props.defaultValue,
        value: this.props.defaultValue[this.state.selectedLanguage.code]
      }, () => {
          this.editorRef.current
              .getInstance()
              .setMarkdown(this.state.valueObject[this.state.selectedLanguage.code]);
      });
    }
  }

  handleLanguageChange(language) {
    const updated = Object.assign({}, this.state.valueObject);
    updated[this.state.selectedLanguage.code] = this.editorRef.current.getInstance().getMarkdown();
    this.setState({ valueObject: updated, selectedLanguage: language }, () => {
      this.editorRef.current.getInstance().setMarkdown(updated[language.code]);
    });
  }

  handleChange() {
    const updated = Object.assign({}, this.state.valueObject);
    const plainMarkdown = this.editorRef.current.getInstance().getMarkdown();
    updated[this.state.selectedLanguage.code] = plainMarkdown;
    this.setState({ valueObject: updated });
    this.props.onChange(updated);

  }

  render() {
    return (
      <div>
        <Form.Group controlId="forLanguage">
          <Form.Label>{this.props.t("Languages.Title")}</Form.Label>
          <BaseSelect
            options={this.languages}
            onChange={s => this.handleLanguageChange(s)}
            value={this.state.selectedLanguage}
            getOptionLabel={option => this.props.t(option.translations)}
            getOptionValue={option => option}
          />
        </Form.Group>
        <Editor
          initialEditType="wysiwyg"
          ref={this.editorRef}
          onChange={this.handleChange}
          disabled={this.props.disabled}
          usageStatistics={false}
          toolbarItems={[
              ["heading", "bold", "italic", "strike"],
              ["hr"],
              ["ul", "ol"]
          ]}
        />
      </div>
    );
  }
}

export default withTranslation()(MarkDownEditor);
